import { selectFieldTilesForNotDeletedBoundaries, Tile } from "model";
import { Layer, Source } from "react-map-gl";
import { useSelector } from "react-redux";

export default function FieldTileLayers({
  editedFieldId,
  fieldIds,
}: {
  editedFieldId?: string;
  fieldIds?: string[];
}) {
  const tiles = useSelector(selectFieldTilesForNotDeletedBoundaries).filter(
    (t) => {
      // Always exclude edited field
      if (t.field === editedFieldId) return false;

      // If fieldIds is provided, only include tiles from those fields
      if (fieldIds && fieldIds.length > 0) {
        return fieldIds.includes(t.field || "");
      }

      // Otherwise include all tiles
      return true;
    }
  );
  return (
    <>
      {tiles.map((t: Tile) => (
        <Source
          id={t.guid}
          key={t.guid + "s"}
          type={t.type}
          tiles={t.tiles}
          scheme={t.scheme}
          bounds={t.bounds}
          tileSize={t.tileSize}
          minzoom={t.minzoom}
          maxzoom={t.maxzoom}
        >
          <Layer
            id={t.guid}
            type={"raster"}
            key={t.guid + "l"}
            layout={{
              visibility: t.visibility,
            }}
            paint={{}}
            beforeId="field-fill" // do we have to also add "arable-field-fill"?
          />
        </Source>
      ))}
    </>
  );
}
